import { buildColor } from "@tvg/design-system";
import styled, { css } from "styled-components";

const rowMargin = css`
  margin-bottom: 24px;
`;

export const Article = styled.article`
  ${rowMargin};

  *:empty::before {
    content: "";
    display: inline-block;
  }

  li {
    margin-left: 24px;
    list-style-type: disc;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 125%;
    color: ${buildColor("grey", "800")};
  }

  h1,
  h2,
  h3 {
    font: 500 16px "Roboto-Medium", sans-serif;
    line-height: 125%;
    margin-bottom: 12px;
  }
`;

export const Title = styled.h2`
  font: 500 16px "Roboto-Medium", sans-serif;
  line-height: 125%;
  margin-bottom: 12px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 125%;
  color: ${buildColor("grey", "800")};
`;

export const FeatureInfoRow = styled.section`
  display: flex;
  align-items: center;
  ${rowMargin};
`;

export const FeatureInfo = styled.article`
  padding-left: 16px;
`;
